import { useState, useEffect } from "react";
import Lottie from "lottie-react";
import useTitanApp from "../../hooks/useTitanApp";

export default function LottieLoader() {
  const { appState } = useTitanApp();
  const { darkMode } = appState;
  const [animData, setAnimData] = useState(null);

  useEffect(() => {
    const file = darkMode
      ? () => import("../../assets/lottie/Loading_DarkMode.json")
      : () => import("../../assets/lottie/Loading_LightMode.json");
    file().then((m) => setAnimData(m.default));
  }, [darkMode]);

  if (!animData) return null;
  return (
    <div className="lottie-loading">
      <Lottie
        animationData={animData}
        loop
        style={{ height: 150, width: 150 }}
      />
    </div>
  );
}
